<div class="modalCancel">
  <div class="backArrowSection">
    <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
  </div>

  <div class="description-img">
      <img src="assets/imgs/new-check-img.svg" alt="{{ 'validationLogoAlt' | translate }}">
  </div>
  <div class="title">{{ 'validationCompleted' | translate }}</div>

  <span class="description">
    {{ 'thisIconIndicatesValidatedAccount' | translate }}
  </span>
</div>
